import {
  Area,
  AreaChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Box, useTheme } from '@ttoss/ui';

import type { MyTheme } from '../../providers/ThemeProvider/theme';

import * as tooltipProps from '../ChartTooltip/tooltipProps';

export type ChartEvapotranspirationProps = {
  data: {
    month: number;
    monthLabel: string;
    evapotranspirationVolume: number;
  }[];
};

const ChartEvapotranspiration = ({ data }: ChartEvapotranspirationProps) => {
  const themeContext = useTheme();

  const theme = themeContext.theme as MyTheme;

  return (
    <Box style={{ width: '100%', height: theme.space[13] }}>
      <ResponsiveContainer debounce={1}>
        <AreaChart
          data={data}
          margin={{
            top: theme.space[6],
            right: theme.space[7],
            bottom: theme.space[6],
            left: theme.space[0],
          }}
        >
          <XAxis
            dataKey="monthLabel"
            tickLine={false}
            fontSize={theme.fontSizes[1]}
            padding={{ left: theme.space[4], right: theme.space[0] }}
          />
          <YAxis
            dataKey="evapotranspirationVolume"
            type="number"
            axisLine={false}
            unit=" mm"
            domain={[0, 'dataMax + 15']}
            interval={2}
            tickLine={false}
            fontSize={theme.fontSizes[1]}
            tickFormatter={(value) => Math.round(value).toString()}
          />
          <Tooltip {...tooltipProps} />
          <Legend
            verticalAlign="top"
            iconSize={theme.fontSizes[1]}
            wrapperStyle={{ fontSize: theme.fontSizes[3] }}
            height={theme.space[9]}
          />
          <Area
            name="Evapotranspiração (mm)"
            type="monotone"
            dataKey="evapotranspirationVolume"
            strokeWidth={2}
            stroke={theme.colors.secondary}
            fill={theme.colors.accent}
            opacity="0.6"
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ChartEvapotranspiration;
